import { createAsyncThunk } from '@reduxjs/toolkit';
import FilesServiceResource from 'api/service/FilesResource';
import { abortAllUploads, abortUploadById } from './upload-cancel-manager';

const cleanupUploadFile = async (file = {}) => {
  const fileIdentifier = file.oid || file.backendId;

  if (!fileIdentifier) {
    return;
  }

  const filesResource = new FilesServiceResource();
  await filesResource.file(fileIdentifier).delete();
};

export const cancelUploadById = createAsyncThunk('files/cancelUploadById', async (fileId, { getState }) => {
  const file = getState().files.importedFiles.find((item) => item.id === fileId);

  abortUploadById(fileId);

  if (file?.status === 'pending') {
    await cleanupUploadFile(file);
  }

  return fileId;
});

export const cancelAllUploads = createAsyncThunk('files/cancelAllUploads', async (_, { getState }) => {
  const pendingFiles = getState().files.importedFiles.filter((item) => item.status === 'pending');

  abortAllUploads();

  if (pendingFiles.length > 0) {
    await Promise.allSettled(pendingFiles.map((file) => cleanupUploadFile(file)));
  }

  return true;
});
